import { ProviderBuilder, EGenMode } from '@educraft/base';
import { TestLatex } from './generators/TestLatex';
import { TestMarkdown } from './generators/TestMarkdown';
import { TestDot } from './generators/TestDot';
import { TestClock } from './generators/TestClock';
import { TestParagraph } from './generators/TestParagraph';
import { TestNotes } from './generators/TestNotes';
import { TestBook } from './generators/TestBook';
import { TestBookAlignment } from './generators/TestBookAlignment';
import { TestBookFloating } from './generators/TestBookFloating';
import { TestBookImage } from './generators/TestBookImage';
import { TestChart } from './generators/TestChart';
import { TestPalette } from './generators/TestPalette';
import { TestSmart } from './generators/TestSmart';
import { TestFraction } from './generators/TestFraction';
import { TestUI } from './generators/TestUI';
import { TestDiff } from './generators/TestDiff';
import { TestTable } from './generators/TestTable';
import { TestSvg } from './generators/TestSvg';
import { TestSudoku } from './generators/TestSudoku';

export function registerLayoutBaseTest(builder: ProviderBuilder) {
  // Test generators
  builder.add(EGenMode.LayoutBaseTest, TestLatex, 'Test.TestLaTeX');
  builder.add(EGenMode.LayoutBaseTest, TestMarkdown, 'Test.Markdown');
  builder.add(EGenMode.LayoutBaseTest, TestDot, 'Test.Dot');
  builder.add(EGenMode.LayoutBaseTest, TestClock, 'Test.Clock');
  builder.add(EGenMode.LayoutBaseTest, TestParagraph, 'Test.Paragraph');
  builder.add(EGenMode.LayoutBaseTest, TestNotes, 'Test.Notes');
  builder.add(EGenMode.LayoutBaseTest, TestBook, 'Test.Book');
  builder.add(EGenMode.LayoutBaseTest, TestBookAlignment, 'Test.BookAlignment');
  builder.add(EGenMode.LayoutBaseTest, TestBookFloating, 'Test.BookFloating');
  builder.add(EGenMode.LayoutBaseTest, TestBookImage, 'Test.BookImage');
  builder.add(EGenMode.LayoutBaseTest, TestChart, 'Test.Chart');
  builder.add(EGenMode.LayoutBaseTest, TestPalette, 'Test.Palette');
  builder.add(EGenMode.LayoutBaseTest, TestSmart, 'Test.Smart');
  builder.add(EGenMode.LayoutBaseTest, TestFraction, 'Test.Fraction');
  builder.add(EGenMode.LayoutBaseTest, TestUI, 'Test.UI');
  builder.add(EGenMode.LayoutBaseTest, TestDiff, 'Test.Diff');
  builder.add(EGenMode.LayoutBaseTest, TestTable, 'Test.Table');
  builder.add(EGenMode.LayoutBaseTest, TestSvg, 'Test.Svg');
  builder.add(EGenMode.LayoutBaseTest, TestSudoku, 'Test.Sudoku');
}
